import { Controller } from "@hotwired/stimulus";
import { checkFiles } from "../helpers";

export default class extends Controller {
  static targets = ["imagePreview", "spinnerLoading"];

  connect() {
    this.initialImage = this.imagePreviewTarget.src;
  }

  upload(event) {
    const { url, inputName } = event.params;
    const file = event.target.files[0];
    
    // Validate image files only
    const [selectedFiles] = checkFiles([file], { imagesOnly: true });
    const reader = new FileReader();

    if (!file) return;

    if (!selectedFiles.length) {
      event.target.value = '';
      return;
    }

    reader.onload = () => {
      this.imagePreviewTarget.src = reader.result;
    };

    this.imagePreviewTarget.style.opacity = 0.5;
    this.spinnerLoadingTarget.classList.remove('d-none');
    reader.readAsDataURL(file);

    const formData = new FormData();
    formData.append(inputName, file)

    $.ajax({
      url: url,
      type: 'PATCH',
      data: formData,
      processData: false,
      contentType: false,
      success: () => {
        this.imagePreviewTarget.style.opacity = 1;
        this.spinnerLoadingTarget.classList.add('d-none');
      },
      error: () => {
        this.imagePreviewTarget.src = this.initialImage;
        this.imagePreviewTarget.style.opacity = 1;
        this.spinnerLoadingTarget.classList.add('d-none');
        event.target.value = '';
      }
    });
  }
}